import { BehaviorSubject } from 'rxjs';
export const getEditClientFormStore = () => {
    const getInitialState = () => ({
        clientDetails: {
            id: 0,
            name: '',
            fiscalIdentifier: '',
            companies: {
                active: 0,
                available: 0
            },
            users: {
                active: 0,
                available: 0
            },
            storage: {
                active: 0,
                available: 0
            },
            roles: {
                active: [],
                available: []
            },
            rolesInUse: [],
            features: [],
            admins: []
        }
    });
    const editClientFormSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => editClientFormSubject.subscribe(callback);
    const setClientDetails = (clientDetails) => {
        editClientFormSubject.next({
            ...editClientFormSubject.getValue(),
            clientDetails
        });
    };
    const getClientId = () => editClientFormSubject.getValue().clientDetails.id;
    const reset = () => {
        editClientFormSubject.next(getInitialState());
    };
    return {
        getInitialState,
        subscribe,
        setClientDetails,
        getClientId,
        reset
    };
};
